import React from 'react'
import { OneColorLogoProps, scaleDimensions } from './utils'

export const RokuLogo: React.FC<OneColorLogoProps> = ({
  height = 24,
  color = '#141414',
  className,
}) => {
  const { width: scaledWidth, height: scaledHeight } = scaleDimensions(
    height,
    78,
    24
  )
  const hex = color

  return (
    <svg
      className={className}
      width={scaledWidth}
      height={scaledHeight}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 79 25"
      fill="none"
      aria-label="Roku"
    >
      <g mask="url(#mask0_807_2611)" fill={hex}>
        <path d="M13.086 8.252a3.978 3.978 0 0 0-3.968-3.984H7.151V12.2h1.967c2.183 0 3.968-1.778 3.968-3.949Zm8.95 15.816h-7.222l-5.735-7.916H7.151v7.9H.785V.32h9.12c5.256 0 9.547 3.556 9.547 7.931 0 2.669-1.645 5.052-4.148 6.51l6.733 9.306Z" />
        <path d="M29.217 9.677c-1.681 0-3.111 2.273-3.111 5.087 0 2.814 1.43 5.09 3.11 5.09 1.721 0 3.149-2.276 3.149-5.09s-1.428-5.087-3.148-5.087Zm9.798 5.087c0 5.375-4.394 9.68-9.798 9.68-5.402 0-9.764-4.305-9.764-9.68 0-5.371 4.362-9.678 9.764-9.678 5.404 0 9.798 4.307 9.798 9.678ZM53.951 5.48l-7.333 7.293V5.456h-6.364v18.596h6.364V16.51l7.656 7.543h8.01l-9.728-9.678 8.058-8.012v11.036c0 3.664 2.215 7.045 7.794 7.045 2.648 0 5.079-1.494 6.26-2.846l2.861 2.455h1.359V5.48h-6.365v12.025c-.716 1.244-1.715 2.026-3.258 2.026-1.566 0-2.285-.923-2.285-3.876V5.48H53.951Z" />
      </g>
    </svg>
  )
}
